import React, { useContext, useState } from "react"
import { redirect, useNavigate, useLocation } from "react-router-dom"
import { FiArrowRight, FiChevronDown } from "react-icons/fi"
import Header from "../Global/Header"
import PageContent from "../Global/PageContent"
import MaskDate from "../../inc/Mask/date"
import updateLead from "../../inc/Fx/updateLead"
import api from "../../services/api"
import axios from "axios"
import { GlobalContext } from "../../contexts/global"
import Alert from "../Global/Alert"

export default function Cadastro() {
  const navigate = useNavigate()
  const location = useLocation()
  const { setLoaderState } = useContext(GlobalContext)

  const [client_name, set_client_name] = useState(
    sessionStorage.getItem("client_name") !== null
      ? sessionStorage.getItem("client_name")
      : "" )
  const [client_email, set_client_email] = useState(
    sessionStorage.getItem("client_email") !== null
      ? sessionStorage.getItem("client_email")
      : "" )
  const [client_nascimento, set_client_nascimento] = useState(
    sessionStorage.getItem("client_nascimento") !== null
      ? sessionStorage.getItem("client_nascimento")
      : "" )

  const [clientGenre, setClientGenre] = useState()
  const [isPopupValidationOpen, setIsPopupValidationOpen] = useState(false)
  const [popupErrorMessage, setPopupErrorMessage] = useState("")
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)

  const getDataNascimentoIso8601 = (string) => {
    const dataNascimento = string.replace(/\D/g, "")
    let dia = dataNascimento.substring(0, 2)
    let mes = dataNascimento.substring(2, 4)
    let ano = dataNascimento.substring(4, 8)
    return `${ano}-${mes}-${dia}`
  }

  const escSqlDataNascimento = (dataISO8601) => {
    return `${getDataNascimentoIso8601(dataISO8601)}T00:00:00.000Z`
  }

  const validarDataNascimento = (valor) => {
    const numeros = valor.replace(/\D/g, "")
    if (numeros.length !== 8) return "Data de nascimento incompleta. Use o formato DD/MM/AAAA."

    const dia = parseInt(numeros.substring(0, 2), 10)
    const mes = parseInt(numeros.substring(2, 4), 10)
    const ano = parseInt(numeros.substring(4, 8), 10)

    if (mes < 1 || mes > 12) return "Mês inválido. Verifique a data de nascimento."
    if (dia < 1 || dia > 31) return "Dia inválido. Verifique a data de nascimento."
    if (ano < 1900) return "Ano inválido. Verifique a data de nascimento."

    // Valida dias por mês (inclui ano bissexto)
    const data = new Date(ano, mes - 1, dia)
    if (data.getFullYear() !== ano || data.getMonth() !== mes - 1 || data.getDate() !== dia) {
      return "Data inválida. Verifique o dia e o mês informados."
    }

    if (data > new Date()) return "A data de nascimento não pode ser uma data futura."

    return null
  }

  const handleDataNascimentoBlur = () => {
    const erroData = validarDataNascimento(client_nascimento)
    if (erroData) {
      setPopupErrorMessage(erroData)
      setIsPopupValidationOpen(true)
      return
    }
    sessionStorage.setItem("client_nascimento", client_nascimento)
    updateLead({
      CLIENT_NASCIMENTO: escSqlDataNascimento(client_nascimento),
    })
  }

  const handleTelemedicinaConexa = async (feegowPatientId) => {
    setLoaderState(true)
    try {
      const body = {
        clientId: sessionStorage.getItem("client"),
        feegowPatientId: feegowPatientId,
        cpf: sessionStorage.getItem("client_cpf").replace(/\D/g, ""),
        telefone: sessionStorage.getItem("client_phone").replace(/\D/g, ""),
        clientName: client_name,
        clientEmail: client_email,
        clientBirthDate: client_nascimento,
        clientGenre: clientGenre,
        isNewToFeegow: true
      }
      const response = await api.post("/telemedicina/resolve", body)
      const { success, content } = response.data
      if (!success) {
        throw new Error(content || "Erro ao gerar link de telemedicina")
      }
      const { webLink, appLink } = content

      if (sessionStorage.getItem("client")) {
        updateLead({ COMPLETE_DATE: new Date().toISOString() })
      }

      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      setLoaderState(false)
      if (isMobile && appLink) {
        window.location.href = appLink
      } else if (webLink) {
        window.open(webLink, "_blank")
        navigate("/")
      } else {
        throw new Error("Links de telemedicina não retornados")
      }
    } catch (error) {
      setLoaderState(false)
      const errorMsg =
        (error.response && error.response.data && error.response.data.content)
          ? error.response.data.content
          : "Não foi possível acessar a telemedicina no momento. Por favor, tente novamente mais tarde."
      setPopupErrorMessage(errorMsg)
      setIsPopupValidationOpen(true)
    }
  }

  const handle_submit = (e) => {
    e.preventDefault()

    setIsPopupValidationOpen(false)
    setPopupErrorMessage("")

    const erroData = validarDataNascimento(client_nascimento)
    if (erroData) {
      setPopupErrorMessage(erroData)
      setIsPopupValidationOpen(true)
      return
    }

    setLoaderState(true)

    api
    .post("/patient-store", {
        clientName: client_name,
        clientEmail: client_email,
        clientBirthDate: escSqlDataNascimento(client_nascimento),
        clientGenre: clientGenre,
        clientPhone: sessionStorage.getItem("client_phone").replace(/\D/g, ""),
        clientCpf: sessionStorage.getItem("client_cpf").replace(/\D/g, ""),
        feegowPatientId: null,
      })
      .then((feegowResp) => {
        const patientId = feegowResp.data.content

        if (!Number.isFinite(Number(patientId))) {
          setLoaderState(false)
          setPopupErrorMessage(
            "Não foi possível completar o cadastro. Por favor, revise seus dados e tente novamente."
          )
          setIsPopupValidationOpen(true)
          return
        }

        sessionStorage.setItem("patient", patientId)
        updateLead({ FEEGOW_PATIENT_ID: patientId })
        updateLead({
          CLIENT_NAME: client_name,
          CLIENT_EMAIL: client_email,
          CLIENT_NASCIMENTO: escSqlDataNascimento(client_nascimento)
        })

        const isFromTelemedicina =
          (location.state && location.state.origem === "telemedicina") ||
          sessionStorage.getItem("origem_cadastro") === "telemedicina"

        if (isFromTelemedicina) {
          sessionStorage.removeItem("origem_cadastro")
          handleTelemedicinaConexa(patientId)
          return
        }

        setLoaderState(false)
        setShowSuccessAlert(true)
      })
      .catch((error) => {
        setLoaderState(false)

        if (axios.isAxiosError(error) && error.response) {
          const { data } = error.response

          if (data.err === "validate") {
            setPopupErrorMessage(
              "Alguns dados informados estão incorretos. Por favor, revise os campos e tente novamente."
            )
          } else {
            setPopupErrorMessage(
              "Não foi possível concluir sua solicitação. Tente novamente mais tarde."
            )
          }
        } else {
          setPopupErrorMessage(
            "Erro de conexão. Verifique sua internet e tente novamente."
          )
        }

        setIsPopupValidationOpen(true)
      })
  }

  const handleCloseAlert = () => {
    setShowSuccessAlert(false)
    navigate("/")
  }

  return (
    <main className="site-main page-cadastro">
      <Header back_to="/convenio" hideFollowUP={true}>
        <h1>Cadastre-se</h1>
      </Header>
      <PageContent>
      {showSuccessAlert && (
        <Alert isOpen={showSuccessAlert} onClose={handleCloseAlert} title="Sucesso">
          <p>Cadastro concluído com sucesso!<br/>Faça login com CPF e celular para continuar.</p>
        </Alert>
        )}
        <p>Complete o seu cadastro e prossiga.</p>
        <form style={{ marginTop: "2rem" }} onSubmit={handle_submit}>
          <div className="input-text" style={{ marginBottom: "2rem" }}>
            <label htmlFor="client_name">
              <p>Nome</p>
              <input
                name="client_name"
                onBlur={() => {
                  updateLead({ CLIENT_NAME: client_name })
                  sessionStorage.setItem("client_name", client_name)
                }}
                value={client_name}
                onChange={(e) => set_client_name(e.target.value)}
                placeholder="Digite o seu nome"
                required
              />
            </label>
          </div>

          <div className="input-text" style={{ marginBottom: "2rem" }}>
            <label htmlFor="client_email">
              <p>E-mail</p>
              <input
                name="client_email"
                onBlur={() => {
                  updateLead({
                    CLIENT_EMAIL: client_email,
                  })
                  sessionStorage.setItem("client_email", client_email)
                }}
                value={client_email}
                onChange={(e) => set_client_email(e.target.value)}
                placeholder="E-mail"
                type="email"
                required
              />
            </label>
          </div>

          <div className="input-text" style={{ marginBottom: "3rem" }}>
            <label htmlFor="client_nascimento">
              <p>Data de nascimento</p>
              <input
                name="client_nascimento"
                onBlur={() => handleDataNascimentoBlur()}
                value={client_nascimento}
                onChange={(e) =>
                  set_client_nascimento(MaskDate(e.target.value))
                }
                placeholder="DD/MM/YYYY"
                maxLength={10}
                required
              />
            </label>
          </div>

          <div className="input-select">
            <label htmlFor="client_genre">
              <select
                name="client_genre"
                id="client_genre"
                onChange={(e) => {
                  setClientGenre(e.target.value)
                  sessionStorage.setItem("client_genre", e.target.value)
                }}
              >
                <option value={0}>Selecione o Sexo</option>
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
              </select>
              <FiChevronDown />
            </label>
          </div>

          {isPopupValidationOpen && (
            <p style={{
              border: "1px solid #e8a598",
              borderLeft: "3px solid #a94442",
              borderRadius: "7px",
              padding: "12px 17px",
              backgroundColor: "#fdf6f4",
              color: "#7a3030",
              fontWeight: 500,
              fontSize: "14px",
              marginTop: "1.5rem",
              marginBottom: "1rem",
            }}>
              {popupErrorMessage}
            </p>
          )}

          <div className="d-flex justify-content-center">
            <div className="input-submit" style={{ position: "initial" }}>
              <button type="submit">
                Prosseguir
                <FiArrowRight />
              </button>
            </div>
          </div>
        </form>
      </PageContent>
    </main>
  )
}
